import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class OrganizationsApi {
  static getOrganizations = ({ search, signal } = {}) => {
    return axios.get(`${API_BASE_URL}/getOrganizations`, {
      params: search ? { search } : undefined,
      signal,
    });
  };

  static getFacilitiesByOrganization = (organizationId) => {
    const params = new URLSearchParams();
    if (organizationId) {
      params.append('organization_id', organizationId);
    }

    return axios.get(`${API_BASE_URL}/facilitiesPro?${params.toString()}`);
  };

  static updateManagedAccountMembership = (
    organizationId,
    managed,
    confirmUnassignment = false,
  ) => {
    return axios.put(
      `${API_BASE_URL}/organizations/${organizationId}/managed-account-membership`,
      { managed, confirm_unassignment: confirmUnassignment },
    );
  };

  static getOrganizationFeatures = async (organizationId) => {
    return (
      await axios.get(
        `${API_BASE_URL}/organization/features?${
          organizationId && `organizationId=${organizationId} `
        }`,
      )
    ).data;
  };

  static updateOrganizationFeatures = (organizationId, features) => {
    return axios.post(
      `${API_BASE_URL}/admin/organization/features?organizationId=${organizationId}`,
      features,
    );
  };

  static getOrganization = (organizationId) => {
    return axios.get(`${API_BASE_URL}/admin/organization/${organizationId}`);
  };

  static updateOrganization = (organizationId, formData) => {
    return axios.put(
      `${API_BASE_URL}/admin/organization/${organizationId}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  };

  static setActiveOrganization = (organizationId) => {
    return axios.post(
      `${API_BASE_URL}/set-active-organization/${organizationId}`,
    );
  };

  static validateCheckSequence = (
    organizationId,
    { checkSequenceEnabled, startingCheckNumber = null },
  ) => {
    return axios.post(
      `${API_BASE_URL}/admin/organization/${organizationId}/check-sequence/validate`,
      { checkSequenceEnabled, startingCheckNumber },
    );
  };

  static getFacilityPortalHandoff = async (organizationId) => {
    return (
      await axios.post(
        `${API_BASE_URL}/admin/facility-portal-handoff/${organizationId}`,
      )
    ).data;
  };
}
